"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signaturesCodec = exports.signatureCodec = void 0;
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
const array_codec_1 = require("./array-codec");
const codec_1 = require("./codec");
exports.signatureCodec = new codec_1.FixedSizeCodec(64);
exports.signaturesCodec = new array_codec_1.ArrayCodec(exports.signatureCodec);
